import { ChangeEvent } from 'react'

import { useEventCapture } from '@surglogs-app/analytics'
import { useHandler } from '@surglogs-app/hooks'
import { useToast } from '@surglogs-app/ui.toast'

import { FILE_UPLOAD_SIZE_LIMIT } from '../constants'
import { useTranslation } from '../services'

export const useFileSizeHandler = ({
  isSingleFileUpload,
  onValidFile,
  onFilesUpload,
}: {
  isSingleFileUpload: boolean
  onValidFile: (file: File) => Promise<any>
  onFilesUpload?: (files: File[]) => void
}) => {
  const { t } = useTranslation()
  const { showErrorToast } = useToast()
  const { captureEvent } = useEventCapture()

  return useHandler((e: ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? [])
    // https://surglogs-inc.sentry.io/issues/4528190206/?project=1495823
    const targetFiles = (isSingleFileUpload ? files.slice(0, 1) : files).filter(
      (file) => file != null,
    )

    onFilesUpload?.(targetFiles)

    targetFiles.forEach((file) => {
      const isTooLarge = file.size > FILE_UPLOAD_SIZE_LIMIT
      if (isTooLarge) {
        captureEvent('file_upload_failed', {
          reason: 'file_too_large',
          fileName: file.name,
          fileSizeMB: Number((file.size / (1024 * 1024)).toFixed(2)),
        })
        showErrorToast({
          title: t('fileTooLarge.title'),
          text: t('fileTooLarge.text', { fileName: file.name }),
        })
      } else {
        onValidFile(file)
      }
    })
  })
}
